import { type FC } from "react";

import { Flexbox } from "../../../../shared/components";
import { TextLink } from "../../../../shared/styles";
import { DisclaimerLinks } from "../../../models";
import { Disclaimer } from "../../shared";

import {
    LensStudioTermsOfServiceLinkText,
    PrivacyPolicyLinkText,
    SubmissionDisclaimerText,
    TermsOfServiceLinkText,
} from "./messages.generated";

interface LensSubmissionDisclaimer {
    className?: string;
}

export const LensSubmissionDisclaimer: FC<LensSubmissionDisclaimer> = ({ className }) => {
    return (
        <Flexbox justifyContent="center" className={className}>
            <Disclaimer>
                <SubmissionDisclaimerText
                    privacyPolicyLink={
                        <TextLink href={DisclaimerLinks.PrivacyPolicy} target="_blank" rel="noopener noreferrer">
                            <PrivacyPolicyLinkText />
                        </TextLink>
                    }
                    lensStudioTermsOfServiceLink={
                        <TextLink href={DisclaimerLinks.LensStudioTerms} target="_blank" rel="noopener noreferrer">
                            <LensStudioTermsOfServiceLinkText />
                        </TextLink>
                    }
                    termsOfServiceLink={
                        <TextLink href={DisclaimerLinks.TermsofService} target="_blank" rel="noopener noreferrer">
                            <TermsOfServiceLinkText />
                        </TextLink>
                    }
                />
            </Disclaimer>
        </Flexbox>
    );
};
